export * from './app-add-bar.component';


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/components/app-add-bar/index.ts